/*
 * Venora — תפריט נגישות.
 * ההעדפות נשמרות ב-localStorage ומוחלות מחדש בסקריפט המוקדם שב-venora-a11y.liquid.
 */
(function () {
  'use strict';

  var KEY = 'venora-a11y';
  var SCALES = [1, 1.15, 1.3, 1.5, 1.75];
  var SPACINGS = [0, 1.7, 2, 2.4];
  var SPACING_LABELS = ['רגיל', 'בינוני', 'גדול', 'מרווח'];
  // הדף בערבית מעביר את התוויות שלו ב-data-labels
  var spacingEl = document.querySelector('[data-va11y-spacing-value][data-labels]');
  if (spacingEl && spacingEl.getAttribute('data-labels').split('|').length === 4) SPACING_LABELS = spacingEl.getAttribute('data-labels').split('|');
  var CLASS_KEYS = ['links', 'readable', 'nomotion', 'cursor', 'keyboard'];

  var root = document.documentElement;
  var widget = document.querySelector('[data-va11y]');
  if (!widget) return;

  var toggle = widget.querySelector('[data-va11y-toggle]');
  var panel = widget.querySelector('#va11y-panel');
  var scaleValue = widget.querySelector('[data-va11y-scale-value]');
  var spacingValue = widget.querySelector('[data-va11y-spacing-value]');

  // רשת ביטחון: /?a11y=reset מאפס הכל גם אם הכפתור לא נראה או לא נגיש
  if (/[?&]a11y=reset\b/.test(window.location.search)) {
    try { localStorage.removeItem(KEY); } catch (e) {}
  }

  var state = load();
  // גדלי הגופן המקוריים, לפי אלמנט — נמדדים פעם אחת כדי שהגדלה חוזרת לא תצטבר
  var originals = null;

  function load() {
    var parsed = {};
    try {
      parsed = JSON.parse(localStorage.getItem(KEY) || '{}');
    } catch (e) {}
    return {
      scale: SCALES.indexOf(parsed.scale) > -1 ? parsed.scale : 1,
      spacing: SPACINGS.indexOf(parsed.spacing) > -1 ? parsed.spacing : 0,
      contrast: ['dark', 'light', 'mono', 'invert'].indexOf(parsed.contrast) > -1 ? parsed.contrast : null,
      links: !!parsed.links,
      readable: !!parsed.readable,
      nomotion: !!parsed.nomotion,
      cursor: !!parsed.cursor,
      keyboard: !!parsed.keyboard,
    };
  }

  function save() {
    try {
      localStorage.setItem(KEY, JSON.stringify(state));
    } catch (e) {}
  }

  /* ---------- הגדלת טקסט ---------- */
  // התמה בנויה על px ו-clamp(), ולכן שינוי font-size על :root לא משפיע.
  // הדרך היחידה שעובדת היא להכפיל את הגודל המחושב של כל אלמנט טקסט בנפרד.

  function measure() {
    originals = [];
    var nodes = document.body.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (widget.contains(el)) continue;
      var tag = el.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'SVG' || tag === 'PATH' || el.closest('svg')) continue;
      var size = parseFloat(window.getComputedStyle(el).fontSize);
      if (size) originals.push([el, size]);
    }
  }

  function applyScale() {
    if (state.scale === 1) {
      if (originals) {
        for (var i = 0; i < originals.length; i++) originals[i][0].style.fontSize = '';
        originals = null;
      }
      root.removeAttribute('data-va11y-scale');
      return;
    }
    if (!originals) measure();
    for (var j = 0; j < originals.length; j++) {
      originals[j][0].style.fontSize = (originals[j][1] * state.scale).toFixed(2) + 'px';
    }
    root.setAttribute('data-va11y-scale', state.scale);
  }

  // אחרי שינוי רוחב חלון ה-clamp() מחשב גדלים אחרים — צריך למדוד מחדש
  var resizeTimer;
  window.addEventListener('resize', function () {
    if (state.scale === 1) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (originals) {
        for (var i = 0; i < originals.length; i++) originals[i][0].style.fontSize = '';
      }
      originals = null;
      applyScale();
    }, 250);
  });

  /* ---------- החלה כוללת ---------- */

  function apply() {
    ['dark', 'light', 'mono', 'invert'].forEach(function (c) {
      root.classList.toggle('va11y-contrast-' + c, state.contrast === c);
    });
    CLASS_KEYS.forEach(function (k) {
      root.classList.toggle('va11y-' + k, state[k]);
    });

    if (state.spacing) root.style.setProperty('--va11y-spacing', state.spacing);
    else root.style.removeProperty('--va11y-spacing');

    applyScale();
    sync();
    save();
  }

  function sync() {
    scaleValue.textContent = Math.round(state.scale * 100) + '%';
    spacingValue.textContent = SPACING_LABELS[SPACINGS.indexOf(state.spacing)] || 'רגיל';

    widget.querySelectorAll('[data-va11y-contrast]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(state.contrast === btn.dataset.va11yContrast));
    });
    widget.querySelectorAll('[data-va11y-toggle-class]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(!!state[btn.dataset.va11yToggleClass]));
    });
  }

  /* ---------- פתיחה, סגירה ומלכודת פוקוס ---------- */

  var lastFocused = null;

  function openPanel() {
    lastFocused = document.activeElement;
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'סגירת תפריט נגישות');
    var first = panel.querySelector('button, a');
    if (first) first.focus();
  }

  function closePanel() {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'פתיחת תפריט נגישות');
    if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
    else toggle.focus();
  }

  toggle.addEventListener('click', function () {
    if (panel.hidden) openPanel();
    else closePanel();
  });

  widget.querySelector('[data-va11y-close]').addEventListener('click', closePanel);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) {
      closePanel();
      return;
    }
    // קיצור מוסכם לפתיחת תפריט נגישות
    if (e.altKey && e.shiftKey && (e.key === 'A' || e.key === 'a')) {
      e.preventDefault();
      if (panel.hidden) openPanel();
      else closePanel();
      return;
    }
    if (e.key !== 'Tab' || panel.hidden) return;

    var items = Array.prototype.filter.call(
      panel.querySelectorAll('button, a[href]'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('click', function (e) {
    if (panel.hidden) return;
    if (!widget.contains(e.target)) closePanel();
  });

  /* ---------- הכפתורים ---------- */

  widget.addEventListener('click', function (e) {
    var btn = e.target.closest('button');
    if (!btn || !widget.contains(btn)) return;

    if (btn.dataset.va11yScale) {
      var si = SCALES.indexOf(state.scale);
      si = btn.dataset.va11yScale === 'up' ? Math.min(si + 1, SCALES.length - 1) : Math.max(si - 1, 0);
      state.scale = SCALES[si];
      apply();
    } else if (btn.dataset.va11ySpacing) {
      var pi = SPACINGS.indexOf(state.spacing);
      pi = btn.dataset.va11ySpacing === 'up' ? Math.min(pi + 1, SPACINGS.length - 1) : Math.max(pi - 1, 0);
      state.spacing = SPACINGS[pi];
      apply();
    } else if (btn.dataset.va11yContrast) {
      state.contrast = state.contrast === btn.dataset.va11yContrast ? null : btn.dataset.va11yContrast;
      apply();
    } else if (btn.dataset.va11yToggleClass) {
      var key = btn.dataset.va11yToggleClass;
      state[key] = !state[key];
      apply();
    } else if ('va11yReset' in btn.dataset) {
      state = { scale: 1, spacing: 0, contrast: null, links: false, readable: false, nomotion: false, cursor: false, keyboard: false };
      apply();
    }
  });

  apply();
})();
